module.exports = __webpack_public_path__ + "img/slide-background.35a8e36a.png";